import React, {useEffect, useRef, useState} from 'react';
import deflate from 'deflate-js';
import cx from 'classnames';
import {Base64} from 'js-base64';
import {SucrineMap} from '@sucrine-map/library'
import '@sucrine-map/library/dist/index.css';

// Detect if mobile. Do not show the scroll overlay if on mobile device
const isMobile = window.matchMedia("(pointer:coarse)").matches;

function App() {
  const [body, setBody] = useState(null);
  const scroller = useRef(null);
  const [scrollRequested, setScrollRequested] = useState(isMobile);
  const [zoomEnabled, setZoomEnabled] = useState(isMobile);

  useEffect(() => {
    function handleScroll() {
      setScrollRequested(true);
    }
    function handleClick(ev) {
      ev.currentTarget.style.pointerEvents = 'none';
    }
    const currentScroller = scroller.current;
    window.addEventListener("wheel", handleScroll);
    currentScroller.addEventListener('click', handleClick)

    return () => {
      window.removeEventListener('wheel', handleScroll);
    }
  }, [scroller]);

  useEffect(() => {
    let timeout = null;
    if (scrollRequested) {
      timeout = setTimeout(() => {
        setScrollRequested(false);
      }, 3000);
    }
    return () => {
      if (timeout !== null) {
        clearTimeout(timeout);
      }
    };
  }, [scrollRequested]);

  function enableZoom() {
    setZoomEnabled(true);
    setScrollRequested(false);
  }

  useEffect(() => {
    if (body) return;
    const params = new URLSearchParams(window.location.search || window.location.hash.replace(/^#/, '?'));
    try {
      const decodedArray = Base64.toUint8Array(params.get('d'));
      const deflateArray = deflate.inflate(decodedArray);
      const jsonString = new TextDecoder('utf-8').decode(new Uint8Array(deflateArray));
      setBody(JSON.parse(jsonString));
    } catch(err) {
      console.log(err);
    }
  }, [body]);

  return (
    <div className="App">
      <div className={cx('masterScrollContainer', {disabled: zoomEnabled, noPointerEvents: !scrollRequested})} ref={scroller}>
        <div
          className={cx('scrollOverlay', {hidden: !(zoomEnabled || scrollRequested)})}
          onClick={enableZoom}
        >Cliquez ici pour activer le zoom sur la carte</div>
      </div>
      {body ? (
        <SucrineMap
          config={body.mc}
          points={body.mp}
          path={body.dv}
          mapOptions={{
            scrollZoom: zoomEnabled
          }}
        />
      ) : null}
    </div>
  );
}

export default App;
